module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footerComponent')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2a286fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer/footer.vue
// module id = 641
// module chunks = 27